import { UPDATE_USER_INFO } from './mutation-types';

export const upadteNameAsync = ({ commit }, name) => {
    setTimeout(() => {
        commit(UPDATE_USER_INFO, name);
    }, 1000);
};
